import { appBorders, appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const MARKERS_OF_SUCCESS_STRINGS = appStrings.modules.markersOfSuccess;

export const PageMarker = () => {
  return (
    <Box sx={containerStyle}>
      <BackrsIcon
        name="IconFlag"
        alt={MARKERS_OF_SUCCESS_STRINGS.pageTitle}
        height={28}
        width={28}
      />
      <Typography sx={titleStyle}>{MARKERS_OF_SUCCESS_STRINGS.pageTitle}</Typography>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  gap: 2,
  boxSizing: 'border-box',
  width: {
    xs: '70%',
    sm: 'fit-content',
  },
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: appColors.color.blue9,
  py: 2,
  px: 3,
  borderBottomRightRadius: '16px',
  borderBottomLeftRadius: '16px',
  ...appBorders.backrsDropShadowBorders.black,
  borderTop: 'none',
  top: {
    xs: '52px',
    sm: '-5px',
  },
  position: 'absolute',
} as const;

const titleStyle: SxProps<Theme> = {
  color: appColors.color.blue1,
  fontWeight: 700,
  fontSize: {
    xs: '18px',
    sm: '22px',
  },
} as const;
